<template>
  <el-dialog title="操作日志" :visible.sync="showModal"  width="820px">
    <div>
      <el-table :data="data" border style="width: 100%;" id="Table">
        <el-table-column prop="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="menuName" label="操作内容" width="250"></el-table-column>
        <el-table-column prop="userName" label="操作人" width=""></el-table-column>
        <el-table-column prop="createTime" label="操作时间"  width="250"></el-table-column>
        <!-- <el-table-column prop="operate" label width="" fixed="right"></el-table-column> -->
      </el-table>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10,20,30,40]"
          :page-size="pageSize"         
          layout="total, sizes, prev, pager, next, jumper"
          :total="length"
        ></el-pagination>
      </div>
    </div>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button type="primary" class="dialogBtn" @click="showModal=false">确 认</el-button>
    </div> -->
  </el-dialog>
</template>

<script>
 import tableMixin from "@/components/Mixin/table";
 import { findLogRecordPage ,} from "@/services/saleclassification";
   
export default {
  mixins: [tableMixin],
  data() {
    return { operatorId: "",moduleId:'', showModal: false };
  },
  methods: {
    openModel(item) {
      console.log(item,"sdsd")
      this.pageIndex = item.page;
      this.pageSize = item.size;
      this.operatorId = item.operatorId;
      this.moduleId = item.moduleId
      this.loadData();
      this.showModal = true;
        
       
    },
    //加载数据
    async queryList() {
    let params={
      moduleId:this.moduleId,
      operatorId:this.operatorId,
      page:this.pageIndex,
      size:this.pageSize
    }
        const response =await findLogRecordPage(params)
    
     
      return response;
    },

    getSearchData() {
      return {};
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/operation/operationLog.vue